import { useContext, useEffect } from 'react';
import UIContext from '../../contexts/ui/UIContext';
import { Route, Routes } from 'react-router-dom';
import TenantManager from './TenantManager';
import AddTenant from './AddTenant';

const TenantManagement = () => {
  const { setInfo } = useContext(UIContext);
  useEffect(() => {
    setInfo('Tenant Management');
  }, []);

  return (
    <div id='tenant-management' className='tenant-management-container'>
      <Routes>
        <Route path={'/'} element={<TenantManager />} />
        <Route path={`/add-new-tenant`} element={<AddTenant />} />
      </Routes>
    </div>
  );
};
export default TenantManagement;
